module.exports = __webpack_public_path__ + "static/media/Twitter.45146e9c.svg";